var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    x: 0,
    y: 0,
    width: 39,
    height: 39,
    patternUnits: "userSpaceOnUse",
    id: "master_svg0_88_24353"
  }, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 39,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAASnSURBVHic7d3hbRRXGIbRbyIKcAe4g7gEdwAd4FQQpwJIB04FQAWUkHUH0MHSAa7g5ocX4VjJi7w7O3f2+hzJEkbG82H50Z3ZmZ2pAgAAAAAAAAAA4FBT7wE4TGvtoqpeVtXF7q8uH33J488f2vzk23+uqm+7P3/bfV5VdTdN0+f//idjEciJaa29qvtf+ovKv/xL+B7Nx2maPnSe5She9B6ArLV2VlWvqup13Qdx1nWgfzur+5luO89xNAJZqdbaeVX9XlVXta4onhWBrMwujLd1HwadCWQldrtSb6vquvcs/CCQFWitva6q92VXanV+6T3Ac9ZaO2utva+qTyWOVbKCdLI7f/Gpqs47j0IgkA52cfxdVo3Vs4u1sNbaVYnjZFhBFvTgYJwTYQVZyG63ShwnRiALcMxxugSyDOc4TpRAjqy1dlM/LkXnxAjkiFprl3V/wSEnSiDH5aD8xAnkSFpr1+Us+ckTyBE8uDKXEyeQ47gur1oNQSDH8ab3AMxDIDPbXWt13nkMZiKQ+Vk9BiKQGe3eT37ZeQxmJJB5ve49APMSyLwuew/AvAQykwc3eGMgApmPCxIH5B2F87nsPcBP3NX9zaq/35B6zptPb2f8XqsikPmscQW5q6qbqvowTdO28ywnSSDz+bX3AI/8WVU30zR9++lX8r88/mAmrbXWe4YHfhv1cQRLc5A+g917ztfiD3HMRyDzWMuVu7fTNN30HmIkApnHWlaQd70HGI1A5rGGFeTrNE2b3kOMRiDjsGt1BAIZx7N46uzSBDKP7rtYdq+OQyDz6H2Q/rXz9oclkDFsew8wKoFAIBAIBDKGTe8BRiUQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgGPb5IK21q6p6s9DmLqrvzeO21e/WPx9HftzCyE+YOq/1PzdwLue7jx7+6rTdRdjF4lBDP+JNIBxq6JtmC4SDjP6QUIFwiNveAxybQCAQCIfY9B7g2AQCgUA4xKb3AMcmEA4x9CtYVQLhANM0DX0OpEog7O+u9wBLEAj7Gn71qBII+9v2HmAJAmFf294DLEEg7Gvbe4AlCIR9bXsPsASBsK9t7wGWIBD2Mk3TtvcMSxAI+/jSe4ClCIR9DH+JyXcCYR/P4iRhlUDYjxUEgk3vAZYiEAgEwpNN07TpPcNSBAKBQHiq4W/185BAeKpn8wpWlUB4umdzDqRq7Lu7bxbc1lVVvVxwe4/d1nL/36W2wyhaa5vW17veP4NR2cWCQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAsGL3gMM4kNVbTpuv+e2AQAAAAAAAAAAIPoHUAYlSz5o/PAAAAAASUVORK5CYII="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 39,
    height: 39,
    rx: 0,
    fill: "url(#master_svg0_88_24353)",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.631ad94c71617306206f31d6d47cccd8.svg";
export { ForwardRef as ReactComponent };